/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        userId: qk_author.author_id,
        is_follow:false,
        is_self:false,
        locked:false,
        loaded:false
    },
    mounted() {
        this.$http.post(qk_rest_url+'checkFollow','user_id='+ this.userId).then(res=>{
            this.is_self = res.data.is_self
            this.is_follow = res.data.is_follow
            this.loaded = true
        }).catch((err) => {
            this.loaded = true;
            qkShowApiError(err, '加载关注状态失败');
        })
    },
    methods: {
        
        saveCover(url, id) {
            this.$http.post(qk_rest_url + 'saveCover', 'url=' + url + '&id=' + id + '&user_id=' + this.userId).then(res=>{
                this.toast.close()
            }).catch((err) => {
                this.toast.close();
                qkShowApiError(err, '保存封面失败');
            })
        },
        onFollow(){
            if(!qktoken) return this.$createModal('login')
            if(this.locked == true) return
            this.locked = true
            
            this.$http.post(qk_rest_url+'userFollow','user_id=' + this.userId).then(res=>{
                this.is_follow = !this.is_follow
                
                this.locked = false
                
                this.$message({ message: '操作成功' , type: 'success' });
            }).catch(err=>{
                this.locked = false
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        },
        whisper(){
            if(!qktoken) return this.$createModal('login')
            window.location.href = window.location.origin + `/message?whisper=${this.userId}`;
        }
    },
    watch: {
        progress(val) {
            this.toast.$elem.firstChild.lastElementChild.innerText = 'Loading...(' + val + '%)';
        }
    }
};
